import { Component } from "@angular/core";
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { TooltipSupportService } from '../../services/tooltip-support/tooltip-support.service';
import { AsyncPipe } from "@angular/common";
import { TranslateDirective } from "@ngx-translate/core";

@Component({
  selector: "sas-support-tooltip",
  standalone: true,
  imports: [AsyncPipe, TranslateDirective],
  templateUrl: "./support-tooltip.component.html",
  styleUrls: ["./support-tooltip.component.scss"],
})
export class SupportTooltipComponent {
  supportPhone: string;
  stateTooltip$: Observable<boolean>;

  constructor(
    private readonly enviroment: EnvironmentService,
    private readonly tooltipSupportService: TooltipSupportService
  ) {
    this.supportPhone = this.enviroment.data.tech_support_phone;
    this.stateTooltip$ = this.tooltipSupportService.getCloseOpenTooltipSupport();
  }

  close(): void {
    this.tooltipSupportService.setCloseOpenTooltipSupport(false);
  }
}
